import React, { useEffect, useState } from 'react';
import { fetchCollection } from './utils';
import { Bar } from 'react-chartjs-2';
import { Chart, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import './login_signup.css';
import { useNavigate } from 'react-router-dom';

Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function TournamentsByUser() {
    const [loading, setLoading] = useState(true);
    const [userCounts, setUserCounts] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            const users = await fetchCollection("users");
            const userIdNameMap = {}
            users.forEach(user => {
                const userId = user.data().userId || "Unknown";
                const userName = user.data().firstName + " " + user.data().lastName;
                userIdNameMap[userId] = userName;
            })
            const docs = await fetchCollection("tournaments");
            const counts = {};
            docs.forEach(doc => {
                const data = doc.data();
                const userId = data.createdBy || "Unknown";
                const userName = userIdNameMap[userId] || "Unknown User";
                counts[userName] = (counts[userName] || 0) + 1;
            });
            setUserCounts(counts);
            setLoading(false);
        }
        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="admin-login-bg">
                <div className="admin-login-card">
                    <div className="admin-login-loading">
                        <div className="admin-login-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    const userIds = Object.keys(userCounts);
    const counts = Object.values(userCounts);

    const data = {
        labels: userIds,
        datasets: [
            {
                label: 'Tournaments Created',
                data: counts,
                backgroundColor: '#2563eb',
                borderRadius: 8,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
        },
        scales: {
            x: {
                title: { display: true, text: 'User ID' },
                ticks: { color: '#374151', font: { size: 13 } },
            },
            y: {
                title: { display: true, text: 'Number of Tournaments' },
                beginAtZero: true,
                ticks: { stepSize: 1, color: '#374151', font: { size: 13 } },
            },
        },
    };

    return (
        <div className="admin-login-bg">
            <div className="admin-login-card" style={{ maxWidth: 900 }}>
                <h1 className="admin-login-title">Tournaments Created by User</h1>
                <button
                    className="admin-login-btn"
                    type="button"
                    style={{ marginBottom: "1.5rem", padding: "0.4rem 1.1rem", fontSize: "0.97rem" }}
                    onClick={() => navigate('/admin')}
                >
                    ← Back to Admin Home
                </button>
                <div style={{ marginTop: "2.5rem" }}>
                    <Bar data={data} options={options} />
                </div>
            </div>
        </div>
    );
}

export default TournamentsByUser;